import React from 'react';

import FormWrapper from 'Components-redesign/FormWrapper';
import { useI18n } from 'Hooks';
import {
  getItems_getItems_results as Item,
  getCompany_company_upsells as Upsell,
} from 'Scenes-redesign/PIM/__queries__';
import UpsellForm from 'Scenes-redesign/PIM/Forms/UpsellForm';

interface Props {
  items: Item[];
  upsells: Upsell[];
  closeModal: () => void;
  handleFormSuccess: (node: any) => void;
}

const CreateUpsell = ({ items, upsells, closeModal, handleFormSuccess }: Props) => {
  const { t } = useI18n();

  return (
    <FormWrapper
      title={t('PIM.CreateUpsell')}
      description={t('PIM.UpsellHeaderDescription')}
      closeModal={closeModal}>
      <UpsellForm
        items={items}
        upsells={upsells}
        onFormSuccess={(node) => handleFormSuccess(node)}
      />
    </FormWrapper>
  );
};

export default CreateUpsell;
